import { Typography } from "@mui/material";

const ThankYou = () => {

    return (
        <div>
            <Typography variant="h4">Muchas gracias por su encargo.</Typography>
            <Typography variant="h4">Procesaremos su orden dependiendo de la prioridad seleccionada.</Typography>
        </div>
    );

}

export default ThankYou